import { promosRequestAction } from './getPromos';
import { TThunkAction } from '../../types/redux/thunk';
import { clearJsonQueryAction, setJsonQueryAction } from '../jsonQuery';

/**
 * Redux action, который запрашивает акции со стандартным состоянием nextJsonQuery
 */
export const loadAllPromosAction = (): TThunkAction<Promise<void>> => async (dispatch, getState) => {
  const prevJsonQuery = getState().jsonQuery;

  try {
    dispatch(clearJsonQueryAction());
    await dispatch(promosRequestAction());
  } catch (e) {
    dispatch(setJsonQueryAction(prevJsonQuery));
  }
};
